export default {
  setEmployerCategories(state, value) {
    state.employerCategories = value
  },
  addEmployerCategories(state, employerCategory) {
    state.employerCategories.unshift(employerCategory)
  },
  updateEmployerCategoriesField(state, payload) {
    try {
      const employerCategory = state.employerCategories.find(employerCategory => employerCategory.id === payload.id)
      employerCategory[payload.key] = payload.value
    } catch (e) {
      throw new SyntaxError(`state.employerCategories не является объектом`)
    }
  },
  removeEmployerCategory(state, index) {
    state.employerCategories.splice(index, 1)
  },
  removeEmployerCategoryAlias(state, payload) {
    state.employerCategories[payload.employerCategoryIndex].aliasesList.splice(payload.aliasIndex, 1)
  },
}
